import { useState } from 'react'

import { useCandidates } from '../candidates/candidatesContext/useCandidatesContext'

import { useMutation } from '@percent/utility'
import { useServices } from '@percent/partner-dashboard/context/serviceContext/ServiceContext'

export type WontDoConfirmation = {
  candidateId: string
  taskId: string
  taskName: string
  candidateName: string
}

export function useMarkTaskWontDo() {
  const { grantsService } = useServices()
  const { candidates, program } = useCandidates()
  const [confirmation, setConfirmation] = useState<WontDoConfirmation | null>(null)
  const [{ isPending }, { mutateAsync: markTaskWontDo }] = useMutation(grantsService.markTaskWontDo, () => {
    setConfirmation(null)
    candidates.refresh()
  })

  const openConfirmation = (params: WontDoConfirmation) => setConfirmation(params)

  const closeConfirmation = () => setConfirmation(null)

  const confirmMarkWontDo = async () => {
    if (!confirmation) return

    const { candidateId, taskId } = confirmation
    await markTaskWontDo({ programId: program.id, candidateId, taskId })
  }

  return {
    confirmation,
    isLoading: isPending,
    openConfirmation,
    closeConfirmation,
    confirmMarkWontDo
  }
}
